<div class="container animated fadeIn consent-form">
  <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
    <!-- <div [innerHTML]="contentData" ></div> -->
    <div class="container hide-scroll-bar" id="A4" style="background: rgba(245, 246, 250, 1.0);padding: 30px;max-width:970px; overflow: scroll; height: 100vh;">
      <div class="A4"
        style="max-width: 828px;margin: auto;display: flex;flex-direction: column; background: rgba(245, 246, 250, 1.0); overflow: auto;">
        <div class="header"
          style="text-align:center;height:67px;width: 100%;padding: 0;background-color: #30346c">
          <img src="assets\images\icons\FM-logo.svg" width="120" style="margin: 20px auto;">
        </div>
        <div class="content p-30" style="height: 100%; overflow: auto;">
          <h3 style="margin:auto;text-align:center;font-size: 20px;margin-bottom: 10px;margin-top: 23px;border-bottom: 1px solid grey;width: max-content;">ACH / Card
          Payment Authorization</h3>

          <p style="line-height: 2;padding: 15px;margin-bottom: 0px;margin-top: 0px">
            I, @if (patient_name()) {
            <strong style="padding-bottom: 2px;border-bottom: 0px solid #656565;"
            >{{patient_name()}}</strong>
          }
          @if (!patient_name()) {
            <strong> ________________________ </strong>
            } authorized signer on this account. I authorize FinanceMutual<sup>TM</sup> to make
            regularly scheduled charges to my Credit Card/Bank account in the amount of my
            FinanceMutual<sup>TM</sup> statement balance for my account, on the payment date indicated. I
            understand and agree that FinanceMutual<sup>TM</sup> will debit my Credit Card/Bank account each
            month via Automatic Clearing House (ACH) debit, even if I have made other
            payments between the statement date and the scheduled payment date, including if
            I paid the statement balance. These charges will appear on my payment methods
            monthly statement and can be reviewed anytime through the FinanceMutual<sup>TM</sup> customer
            portal.
          </p>
          <div style="line-height: 2;padding: 0 15px 15px 15px;margin-bottom: 0px;margin-top: 0px">
            By enrolling in FinanceMutual<sup>TM</sup>’ recurring Automatic Monthly Payment Program
            ("Automatic Monthly Payment Program"), I also acknowledge the following:
            <ul style="margin-top:12px;">
              <li>If the scheduled date of any electronic funds transfer ("EFT") falls on a
                weekend or holiday, my EFT can be initiated as of the next business day.
              </li>
              <li>If any EFT is returned or dishonored for any reason, including
                non-sufficient funds, a stop payment order, or a closed account, FinanceMutual<sup>TM</sup>
                may at its discretion attempt to process the charge again. I further agree
                to an additional <span class="notranslate"> {{currency_data()?.display_logo}} 25.00</span> charge for each returned or dishonored EFT which will
                be initiated as a separate transaction from the authorized recurring
              payment.</li>
              <li>I agree not to dispute this recurring billing with my financial institution
                so long as the transactions correspond to the terms indicated in this
              authorization form.</li>
              <li>I understand that this authorization will remain in effect unless I cancel
                it in writing, and I agree to notify legal&#64;financemutual.com in writing of any
                changes in my account information or termination of this authorization at
              least 15 days prior to the next billing date.</li>
            </ul>
          </div>
          <h4 style="padding: 0 15px;margin-bottom: 0;margin-top: 19px;">Payment for Service
          </h4>
          <p style="line-height: 2;padding: 0 15px;margin-top: 0px">I accept that I am
            financially responsible for all services rendered on my behalf for which a
            charge may be associated. I accept personal responsibility for all payments,
            down payments, late fees, plus any collection costs for amounts personally owed
          by me.</p>
          <h4 style="padding: 0 15px;margin-bottom: 0;margin-top: 19px;">Unpaid Account
          Balances</h4>
          <p style="line-height: 2;padding: 0 15px;margin-bottom: 0px;margin-top: 0px">
            I acknowledge that if I fail to make payments for services rendered, my account
            may be turned over to a collection agency. I will be responsible to pay the
            collection agency’s fees that may be incurred in the collection of any
            outstanding balance.
          </p>
          <h4 style="padding: 0 15px;margin-bottom: 0;margin-top: 19px;">Credit Reporting</h4>
          <p style="line-height: 2;padding: 0 15px;margin-bottom: 0px;margin-top: 0;">
            FinanceMutual<sup>TM</sup> may report my payment activities to credit bureaus as an installment
            payment to help build credit. FinanceMutual<sup>TM</sup> may also report my defaulted debt to
            credit bureaus after payment is 31 days or more past due.
          </p>

          <h4 style="padding: 0 15px;margin-top:30px;"> Agreement to Accept Terms and Conditions,
            Periodic Statements, Notices, Confirmations and Disclosures in an Electronic
          Format.</h4>
          <p style="line-height: 2;padding: 15px;margin-bottom: 0px;margin-top: 0px">
            <span> this Agreement, the terms "we", "us" and "our" refer to FinanceMutual<sup>TM</sup> Corporation
            ("FinanceMutua<sup>TM</sup>l"), and the terms "you" and "your" refer to you as a FinanceMutual<sup>TM</sup>
            customer. This Agreement applies to all FinanceMutual<sup>TM</sup> accounts established with
          you (each is an "Account").</span>
          <span style="display:block;line-height: 2;padding: 7px 0;margin-bottom: 0px;margin-top: 0px">
            This Electronic Disclosure and Consent contains important information that
            you are entitled to receive before you consent() to transact business with us
          electronically.</span>
        </p>
        <h4 style="padding: 0 15px;margin:0;">Electronic Acceptance of Account Terms.
        </h4>
        <p style="line-height: 2;padding: 15px;margin-bottom: 0px;margin-top: 0px">
          You acknowledge and agree that (a) the Terms and Conditions applicable to your
          Account(s) (the "Account Terms"), any amendments to the Account Terms, and any
          one-time authorization for an electronic funds transfer ("EFT") or
          preauthorization for EFTs to pay amounts due and payable under my Account can be
          entered into electronically and enforceable in accordance with laws applicable
          to the recognition of electronic signatures, including without limitation the
          Electronic Signatures in Global and National Commerce Act (the E-SIGN Act); (b)
          the electronic signature utilizing the designated method constitutes your
          signature, acceptance, and agreement the same as if actually signed in writing;
          and (c) this Agreement shall constitute an "original" document when printed from
          electronic files and records established and maintained by either party in the
        normal course of business.</p>
        <h4 style="padding: 0 15px;margin:0;margin-top:30px">Consent to Receive Records in
        an Electronic Format</h4>
        <p style="line-height: 2;padding: 0px 15px;margin-bottom: 0px;margin-top: 0px">
          <span>By clicking your acceptance below, you hereby agree to electronic delivery
            of notices and records relating to your Account ("Records") in lieu of
            receiving such Records in paper form through postal delivery and not
            otherwise required by regulation or policy to be sent exclusively by postal
            delivery. Records eligible for electronic delivery include periodic
            statements of your Account. By agreeing to electronic delivery, you will not
          receive these disclosures by mail.</span>
          <span style="display:block;line-height: 2;padding: 7px 0;margin-bottom: 0px;margin-top: 0px">
            We may always, in our sole discretion, provide you with any communication of
            Records in writing, even if you have chosen to receive it
          electronically.</span>
          <span style="display:block;line-height: 2;padding: 7px 0;margin-bottom: 0px;margin-top: 0px">
            You acknowledge and agree that your consent() above is being provided in
            connection with a transaction affecting interstate commerce that is subject
            to the E-SIGN Act, and that you and we both intend that the E-SIGN ACT apply
            to the maximum extent to permit us the ability to conduct business with you
          by electronic means.</span>
        </p>

        <h4 style="padding: 0 15px;margin:0;margin-top:20px">Changes of Terms; Termination
        </h4>
        <p style="line-height: 2;padding: 0px 15px;margin-bottom: 0px;margin-top: 0px">
          We reserve the right, at any time and in our sole discretion, to change the
          terms and conditions under which we provide Records to you electronically, or to
          discontinue providing Records to you electronically. We will provide you with
          advance notice of any such change or termination. Your decision to continue to
          receive Records electronically will constitute your agreement to any such
          change.
        </p>
        <h4 style="padding: 0 15px;margin:0;margin-top:20px">HIPAA (Health Insurance
        Portability and Accountability Act) Disclosure</h4>
        <p style="line-height: 2; padding: 0px 15px; margin-bottom: 0px; margin-top: 0px;">
          I consent() that if
          <strong style="padding-bottom: 2px; border-bottom: 0px solid #656565;" >{{doctor_practice_name()}}
          </strong>
          @if (!practice_name() && !doctor_name()) {
            <strong>
              ________________________
            </strong>
          }
          is a medical provider of any sort, it may use and disclose Protected Health Information (PHI) or Individually Identifiable Health Information (IIHI) about me to carry out Treatment, Payment, and Healthcare operations (TPO). I,
          @if (patient_name()) {
            <strong style="padding-bottom: 2px; border-bottom: 0px solid #656565;"
              >
              {{ patient_name() }}
            </strong>
          }
          @if (!patient_name()) {
            <strong>
              ________________________
            </strong>
            },
            authorize
            @if (doctor_practice_name()) {
              <strong style="padding-bottom: 2px; border-bottom: 0px solid #656565;"
                >
                {{ doctor_practice_name() }}
              </strong>
            }
            @if (!practice_name() && !doctor_name()) {
              <strong>
                ________________________
              </strong>
            }
            to release my protected health information to FinanceMutual<sup>TM</sup>.
          </p>

          <br>
            <p style="width:50%;min-height: 20px;float:left;padding: 0;margin: 0 15px;font-weight: bold;padding-bottom: 2px;border-bottom: 1px solid #656565;">{{patient_name()}}</p>
            <div class="clearfix"></div>
            <p style="padding: 0 15px 0">Name (printed)</p>
          </div>
          <div class="footer" style="padding-bottom: 50px;">
            <!-- <img src="assets\images\icons\FM-logo.svg" width="120"
            style="margin: 18px 12px 25px"> -->
            <span>ACH / Card Payment Authorization&nbsp;&nbsp;|&nbsp;&nbsp;</span><span>support&#64;financemutual.com&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span>FinanceMutual<sup>TM</sup> LLC, 1 Technology Drive, Building J, Ste 703 Irvine, CA 92618, United States</span>
          </div>
        </div>
      </div>
    </div>
    <style>
      @media (max-width: 490px) {
      p {
      padding-top: 5px !important;
    }
    #A4,
    .A4 {
    width: 100% !important;
  }

  #A4,
  .content {
  padding: 1rem !important;
}

.content h4 {
width: 100% !important;
}
}

@media (min-width: 490px) and (max-width: 1024px) {

#A4,
.A4 {
width: 100% !important;
}

#A4,
.content {
padding: 30px !important;
}

.content h4 {
width: 50% !important;
}
}
</style>
</div>